import {
  closestCenter,
  pointerWithin,
  type CollisionDetection
} from '@dnd-kit/core';

/** Prefer the list under the pointer; fall back to nearest center. */
export const boardCollisionDetection: CollisionDetection = (args) => {
  const pointerHits = pointerWithin(args);
  if (pointerHits.length > 0) return pointerHits;
  return closestCenter(args);
};
